import FileUploadUtils from "utils/shared/file_upload_utils.js"
import GoogleAnalyticsTracker from 'utils/shared/google_analytics_tracker.js'

export default class ProfileEditView extends Backbone.View
  events:
    "change #user_country"              : "load_subregions"
    "change #user_avatar"               : "avatar_upload_change"
    "keyup .js-character-count"         : "updateCount"
    "click .js-avatar-delete"           : "deleteAvatar"
    "click .js-avatar-edit"             : "triggerUpload"

  initialize: (options) ->
    @$subregion_wrapper = @$('.subregion')
    @$user_country = @$('#user_country')
    @$redirect_url = options.redirect_url
    @imageTargetSize = options.imageTargetSize || 100

    @$user_avatar_img = @$(".js-avatar-image")
    @$user_avatar_wrapper = @$(".photo-wrapper")
    @$user_avatar_height = @$user_avatar_img.height()
    @$avatar_upload = @$("#user_avatar")
    @$delete_photo_button = @$(".delete-button-wrapper")
    @$remove_photo_input = @$("#remove_photo")
    @load_subregions()

  triggerUpload: ->
    @$("input#user_avatar").trigger("click")

  updateCount: (e) ->
    $input = $(e.target)
    $input.siblings(".subtext").find(".js-current-count").text($input.val().length)

  load_subregions: ->
    url = "/account/subregion_options?parent_region=#{@$user_country.val()}"
    @$subregion_wrapper.load url, =>
      @.$subregion_wrapper.find('select').select2(minimumResultsForSearch: 10)

  avatar_upload_change: (event) ->
    if $.trim(@$avatar_upload.val()).length > 0
      avatar_input = @$avatar_upload.get(0)
      if Modernizr.filereader && !!avatar_input.files && avatar_input.files.length > 0
        that = this
        FileUploadUtils.load_locally(avatar_input.files[0], this, (src) ->
          image = new Image()
          image.onload = ->
            that.$user_avatar_img
              .attr("src", src)
              .removeClass("avatar fit-width fit-height")
              .removeAttr("width height style")
            if image.height > image.width
              that.$user_avatar_img
                .addClass("fit-width")
                .css("margin-top", "-#{(that.$user_avatar_img.height()-that.imageTargetSize)/2}px")
            else if image.width > image.height
              that.$user_avatar_img
                .addClass("fit-height")
                .css("margin-left", "-#{(that.$user_avatar_img.width()-that.imageTargetSize)/2}px")
            else
              that.$user_avatar_img.attr
                "width": that.$user_avatar_height,
                "height": that.$user_avatar_height
          image.src = src
        )
      else
        @$user_avatar_wrapper.replaceWith("Your picture has been added but your browser doesn't support showing a preview of it. Hit save to upload it.")

      @$delete_photo_button.show()
      @$remove_photo_input.val("false")
      GoogleAnalyticsTracker.page_event('upload-profile-photo')

  deleteAvatar: (e) ->
    @$delete_photo_button.hide()
    @$user_avatar_img
      .attr("src", "/images/default_avatar.png")
      .removeAttr("style")
    @$avatar_upload.wrap('<form>').closest('form').get(0).reset()
    @$avatar_upload.unwrap()
    @$remove_photo_input.val("true")



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/profile_edit_view.js.coffee